import { zSchema } from "@zeal/common";

export const deleteAiConversationRequestSchema = zSchema.object({
  companyId: zSchema.string().min(1),
  conversationId: zSchema.string().min(1),
  userId: zSchema.string().min(1),
});

export type TDeleteAiConversationRequestSchema = zSchema.infer<
  typeof deleteAiConversationRequestSchema
>;

export const deleteAiConversationResponseSchema = zSchema.object({
  deleted: zSchema.literal(true),
});

export type TDeleteAiConversationResponseSchema = zSchema.infer<
  typeof deleteAiConversationResponseSchema
>;
